import { render, staticRenderFns } from "./SelectPage.vue?vue&type=template&id=0cf9ea88"
import script from "./SelectPage.vue?vue&type=script&lang=js"
export * from "./SelectPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cf9ea88')) {
      api.createRecord('0cf9ea88', component.options)
    } else {
      api.reload('0cf9ea88', component.options)
    }
    module.hot.accept("./SelectPage.vue?vue&type=template&id=0cf9ea88", function () {
      api.rerender('0cf9ea88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/SelectPage.vue"
export default component.exports